'use strict';

var DataExtractScheduledPanelDirective = function DataExtractScheduledPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/data-extract-scheduled.html'),
    controller: 'DataExtractScheduledController'
  };
};
DataExtractScheduledPanelDirective.$inject = [];
module.exports = DataExtractScheduledPanelDirective;